import {
  Box,
  Flex,
  Text,
  useColorMode,
  useColorStyle,
  Button,
} from '@tonic-one/react';
import browserWarning from '../../../../assets/image/browser-warning.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
export default () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const FlexItem = (props: any) => (
    <Box display="inline" verticalAlign="middle" fontSize="14px" {...props} />
  );
  return (
    <Box p="160px 96px">
      <Flex>
        <FlexItem flex="auto">{}</FlexItem>
        <FlexItem width="675px" height="262px" textAlign="center">
          <img src={browserWarning} />
          <Text m="20px 0px 8px 0px" fontSize="16px" lineHeight="22px">
            {t(
              'welcome.enableCloudEmailAndCollaborationProtection.label.noPermission'
            )}
          </Text>
          <Text
            color={colorStyle.color.secondary}
            fontSize="14px"
            lineHeight="20px"
          >
            {t(
              'welcome.enableCloudEmailAndCollaborationProtection.label.noPermissionDesc'
            )}
          </Text>
          <Button
            variant="secondary"
            mt={8}
            onClick={() => {
              window.location.reload();
            }}
          >
            {t(
              'welcome.enableCloudEmailAndCollaborationProtection.label.noPermissionTryAgain'
            )}
          </Button>
        </FlexItem>
        <FlexItem flex="auto">{}</FlexItem>
      </Flex>
    </Box>
  );
};
